/* T FOR ALL — product page: videos in the photo gallery play (muted) as soon as they are on
   screen, when swiping to them on mobile or scrolling to them on desktop, and pause when
   they leave. Loads the video from Dawn's deferred-media template without pausing others. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  function videoOf(media) {
    var video = media.querySelector(':scope > video');
    if (video) return video;
    var template = media.querySelector('template');
    var source = template && template.content.firstElementChild;
    if (!source || source.nodeName !== 'VIDEO') return null;
    video = source.cloneNode(true);
    video.muted = true;
    media.setAttribute('loaded', true);
    media.appendChild(video);
    return video;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var media = entry.target;
      if (entry.isIntersecting) {
        var video = videoOf(media);
        if (!video) return;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      } else {
        var current = media.querySelector(':scope > video');
        if (current) current.pause();
      }
    });
  }, { threshold: 0.6 });

  function observe() {
    document.querySelectorAll('media-gallery deferred-media').forEach(function (media) {
      if (media.dataset.tfaVideo) return;
      var template = media.querySelector('template');
      var source = template && template.content.firstElementChild;
      if (!source || source.nodeName !== 'VIDEO') return;
      media.dataset.tfaVideo = '1';
      observer.observe(media);
    });
  }

  if (document.readyState !== 'loading') observe();
  else document.addEventListener('DOMContentLoaded', observe);
  // The gallery is rebuilt after a colour change
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { window.setTimeout(observe); });
  }
})();
